/* Copyright (c) 2026 Health Endeavors, LLC. All Rights Reserved */

import { ruleExtractImagings } from './rules/imagings';
import { ruleExtractLabs } from './rules/labs';
import { ruleExtractProcedures } from './rules/procedures';
import { Rule } from './types';

export const ruleConfig: Rule[] = [
  {
    name: 'Extract Labs',
    type: 'Labs',
    execute: ruleExtractLabs,
  },
  {
    name: 'Extract Imagings',
    type: 'Diagnostics',
    execute: ruleExtractImagings,
  },
  {
    name: 'Extract Procedures',
    type: 'Procedure',
    execute: ruleExtractProcedures,
  },
];
